// The no-map Geolocation variant. Markup is shared with the map variant — see GeolocationTemplates.js.
const { buildGeolocationTemplates } = require('./GeolocationTemplates.js');

module.exports = buildGeolocationTemplates('GeolocationSelector');
